import { render, staticRenderFns } from "./CisTableView.vue?vue&type=template&id=064ec5de&scoped=true"
import script from "./CisTableView.vue?vue&type=script&lang=js"
export * from "./CisTableView.vue?vue&type=script&lang=js"
import style0 from "./CisTableView.vue?vue&type=style&index=0&id=064ec5de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064ec5de",
  null
  
)

export default component.exports